import Head from 'next/head'

export default function Meta() {
    return (
        <Head>
            <link rel="manifest" href="../favicons/site.webmanifest" />
            <link key="fav1" rel="apple-touch-icon" sizes="180x180" href="../favicons/apple-touch-icon.png" />
            <link key="fav2" rel="icon" type="image/png" sizes="32x32" href="../favicons/favicon-32x32.png" />
            <link key="fav3" rel="icon" type="image/png" sizes="16x16" href="../favicons/favicon-16x16.png" />
            <link key="fav5" rel="mask-icon" href="../favicons/safari-pinned-tab.svg" color="#5bbad5" />
            <link key="fav6" rel="shortcut icon" href="../favicons/favicon.ico" />
            <link rel="alternate" type="application/rss+xml" href="/feed.xml" />
            <meta
                name="description"
                content="Whether you're a buyer, a broker, an owner or tenant, Zonado Insights is everything you need to keep up on Commercial Real Estate and sale of business news, hot tips, and trends."
            />
            {/* <meta property="og:image" content={HOME_OG_IMAGE_URL} /> */}
        </Head>
    )
}
